/* Package JSON Import will be here */
import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as moment from 'moment';
/* Package JSON Import will be here */

/* Project Import will be here */
import Api from '../../services/api/serviceCall';
import TMVoucherComponent from './tmVoucher.Component';
import { ApiUrls } from '../../services/api';
import { Constants } from '../../config/appConstants';
import { MessageBox } from '../sharedComponent/messageBox';
import * as actions from '../../actions/login.Action';
/* Project Import will be here */

class TMVoucher extends Component {
    constructor(props) {
        super(props);
        var todayDate = new Date();
        var selectFromDate = new Date();
        var diff = selectFromDate.getDate() - selectFromDate.getDay() + (selectFromDate.getDay() === 0 ? -6 : 1);
        selectFromDate = new Date(selectFromDate.setDate(diff));
        this.state = {
            voucherList: [],
            revisionList: [],
            isShowAttachments: false,
            isShowTMVoucherPDF: false,
            isShowRevisionModal: false,
            isAttachmentModelVisible: false,
            selectedAttachmentContent: '',
            selectedTMVoucher: '',
            selectedTMVoucherAttachments: [],
            selectedRevisionTMVoucher: {},
            selectedToDate: todayDate,
            selectedFromDate: selectFromDate,
            defaultFromDate: selectFromDate,
            defaultToDate: todayDate,
            revisionSelectedTimecardDate: null,
            tmVoucherSelectedTimecardDate: null,
            tMVoucherEmployeeSearchText: '',
            tMVoucherDeviceNameSearchText: '',
            tMVoucherTimecardDateSearchText: '',
            tMVoucherProjectSearchText: '',
            tMVoucherTaskCodeSearchText: '',
            tMVoucherSyncedDateSearchText: '',
            tMVoucherVersionSearchText: '',
            tMVoucherStatusSearchText: '',
            tMVoucherNumberSearchText: '',
            tMVoucherSelectedSyncDate: null,
            revisionEmployeeSearchText: '',
            revisionDeviceNameSeachText: '',
            revisionTimecardDateSearchText: '',
            revisionProjectSearchText: '',
            revisionTaskCodeSearchText: '',
            revisionSyncedDateSearchText: '',
            revisionVersionSearchText: '',
            revisionStatusSearchText: '',
            revisionNumberSearchText: '',
            revisionSelectedSyncDate: null,
            pagination: {
                activePage: 1,
                totalCount: 0,
                skip: Constants.DEFAULT_SKIP,
                take: Constants.DEFAULT_TAKE
            },
            signatureOptions: [
                { id: 0, text: Constants.TM_VOUCHER_SIGNATURE_YES, value: Constants.TM_VOUCHER_SIGNATURE_YES },
                { id: 1, text: Constants.TM_VOUCHER_SIGNATURE_NO, value: Constants.TM_VOUCHER_SIGNATURE_NO },
            ],
            selectedSignatureTMVoucherOptions: [],
            selectedSignatureRevisionOptions: [],
            isCheckedArchive: false,
            lastArchiveDate: null,
            minimumDate: null,
            maximumDate: null,
            isDatePickerEnabled: false
        };
    }

    componentDidMount() {
        this.getTMVoucherList(true);
    }

    getTMVoucherData() {
        setTimeout(
            () => this.getTMVoucherList(),
            1000
        );
    }

    splitDeviceName(deviceName) {
        let modifiedDeviceName = deviceName.split('_');
        modifiedDeviceName.shift();
        modifiedDeviceName.pop();
        return modifiedDeviceName.join('_');
    }

    getTMVoucherList(initialCall = false) {
        let { pagination, selectedFromDate, selectedToDate, defaultToDate, defaultFromDate, minimumDate, lastArchiveDate } = this.state;
        var dateRangeFrom = selectedFromDate == null ? new Date(defaultFromDate) : new Date(selectedFromDate);
        var dateRangeTo = selectedToDate == null ? new Date(defaultToDate.getTime() + 1 * 24 * 60 * 60 * 1000) : new Date(selectedToDate.getTime() + 1 * 24 * 60 * 60 * 1000);
        var startTime = new Date(dateRangeFrom.setHours(0, 0, 0));
        var startDate = new Date(startTime.setMinutes(startTime.getTimezoneOffset()));
        var endTime = dateRangeTo.setDate(dateRangeTo.getDate());
        var endDate = new Date(endTime);
        endDate.setHours(0, 0, 0);
        var dateEndTime = new Date(endDate.setMinutes(endDate.getTimezoneOffset()));
        var selectDate = moment(startDate).format('DD-MM-YYYY');
        var dateSelected = moment(dateEndTime).format('DD-MM-YYYY');
        var timeZone = startDate.toString();
        var selectTimeZone = timeZone.slice(16, 24);
        var fromDate = `${selectDate} ${selectTimeZone}`;
        var toDate = `${dateSelected} ${selectTimeZone}`;
        let url = `${ApiUrls.Routes.TMVOCHR_C}${ApiUrls.Routes.GT_TMVOCHR_LT_M}?fromDate=${fromDate}&toDate=${toDate}&&isCheckedArchive=${this.state.isCheckedArchive}`;
        let requestData = {
            SearchText: this.buildSearchRequestArray(true),
            Skip: pagination.skip,
            Take: pagination.take
        }
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData && responseData.success) {
                pagination.totalCount = Math.ceil(responseData.totalCount / Constants.DEFAULT_TAKE);
                let voucherList = responseData.data.tmVoucherList;
                if (initialCall && responseData.data.lastArchiveDate) {
                    let archiveDate = new Date(responseData.data.lastArchiveDate);
                    archiveDate = new Date(archiveDate.setDate(archiveDate.getDate() + 1));
                    minimumDate = archiveDate;
                    lastArchiveDate = archiveDate;
                }
                this.setState({
                    voucherList: voucherList,
                    pagination,
                    lastArchiveDate,
                    isDatePickerEnabled: true,
                    ...(initialCall && { minimumDate })
                });
            }
        });
    }

    onSearchChange(e, searchName) {
        let { isShowRevisionModal } = this.state;
        switch (searchName) {
            case Constants.TM_VOUCHER_EMPOYLEE_SEARCH:
                if (isShowRevisionModal) {
                    this.setState({ revisionEmployeeSearchText: e.target.value }, () => {
                        this.getRevisionList();
                    });
                } else {
                    this.setState({ tMVoucherEmployeeSearchText: e.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE } }, () => {
                        this.getTMVoucherData();
                    });
                }
                break;
            case Constants.TM_VOUCHER_DEVICENAME_SEARCH:
                if (isShowRevisionModal) {
                    this.setState({ revisionDeviceNameSeachText: e.target.value }, () => {
                        this.getRevisionList();
                    });
                } else {
                    this.setState({ tMVoucherDeviceNameSearchText: e.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE } }, () => {
                        this.getTMVoucherData();
                    });
                }
                break;
            case Constants.TM_VOUCHER_PROJECT_SEARCH:
                if (isShowRevisionModal) {
                    this.setState({ revisionProjectSearchText: e.target.value }, () => {
                        this.getRevisionList();
                    });
                } else {
                    this.setState({ tMVoucherProjectSearchText: e.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE } }, () => {
                        this.getTMVoucherData();
                    });
                }
                break;
            case Constants.TM_VOUCHER_TASKCODE_SEARCH:
                if (isShowRevisionModal) {
                    this.setState({ revisionTaskCodeSearchText: e.target.value }, () => {
                        this.getRevisionList();
                    });
                } else {
                    this.setState({ tMVoucherTaskCodeSearchText: e.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE } }, () => {
                        this.getTMVoucherData();
                    });
                }
                break;
            case Constants.TM_VOUCHER_VERSION_SEARCH:
                if (isShowRevisionModal) {
                    this.setState({ revisionVersionSearchText: e.target.value }, () => {
                        this.getRevisionList();
                    });
                } else {
                    this.setState({ tMVoucherVersionSearchText: e.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE } }, () => {
                        this.getTMVoucherData();
                    });
                }
                break;
            case Constants.TM_VOUCHER_STATUS_SEARCH:
                if (isShowRevisionModal) {
                    this.setState({ revisionStatusSearchText: e.target.value }, () => {
                        this.getRevisionList();
                    });
                } else {
                    this.setState({ tMVoucherStatusSearchText: e.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE } }, () => {
                        this.getTMVoucherData();
                    });
                }
                break;
            case Constants.TM_VOUCHER_NUMBER_SEARCH:
                if (isShowRevisionModal) {
                    this.setState({ revisionNumberSearchText: e.target.value }, () => {
                        this.getRevisionList();
                    });
                } else {
                    this.setState({ tMVoucherNumberSearchText: e.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE } }, () => {
                        this.getTMVoucherData();
                    });
                }
                break;
            case Constants.TM_VOUCHER_SIGNATURE_SEARCH:
                if (this.state.isShowRevisionModal) {
                    this.getRevisionList();
                } else {
                    this.getTMVoucherList();
                }
                break;
            default:
                break;
        }
    }

    handleSyncDateChange(date) {
        let { isShowRevisionModal } = this.state;
        if ((new Date(date) !== "Invalid Date") && !isNaN(new Date(date)) && date != null) {
            if (isShowRevisionModal) {
                this.setState({
                    revisionSelectedSyncDate: date, revisionSyncedDateSearchText: date
                }, () => {
                    this.getRevisionList();
                });
            } else {
                this.setState({
                    tMVoucherSelectedSyncDate: date, tMVoucherSyncedDateSearchText: date,
                    pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 }
                }, () => {
                    this.getTMVoucherData();
                });
            }
        }
        else {
            if (isShowRevisionModal) {
                this.setState({
                    revisionSelectedSyncDate: null, revisionSyncedDateSearchText: "",
                    revisionList: []
                }, () => {
                    this.getRevisionList();
                });
            } else {
                this.setState({
                    tMVoucherSelectedSyncDate: null, tMVoucherSyncedDateSearchText: "",
                    voucherList: []
                }, () => {
                    this.getTMVoucherData();
                });
            }
        }
    }

    handleTimecardDateChange(date) {
        let revisionSelectedTimecardDate = null;
        let timecardDateSearchText = '';
        if ((new Date(date) !== "Invalid Date") && !isNaN(new Date(date)) && date != null) {
            revisionSelectedTimecardDate = moment(date, "MM/DD/YYYY").format("MM/DD/YYYY");
            timecardDateSearchText = moment(date, "MM/DD/YYYY").format("MM/DD/YYYY");
        }
        if (this.state.isShowRevisionModal) {
            this.setState({
                revisionTimecardDateSearchText: timecardDateSearchText,
                revisionSelectedTimecardDate: revisionSelectedTimecardDate, revisionList: []
            }, () => {
                this.getRevisionList();
            });
        } else {
            this.setState({
                tMVoucherTimecardDateSearchText: timecardDateSearchText,
                tmVoucherSelectedTimecardDate: revisionSelectedTimecardDate, voucherList: [],
                pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 }
            }, () => {
                this.getTMVoucherData();
            });
        }
    }

    handleToDateChange(date) {
        if ((new Date(date) !== "Invalid Date") && !isNaN(new Date(date))) {
            if (date === null) {
                MessageBox(Constants.SELCET_TO_DATE, Constants.ERROR);
            }
            else if (date < this.state.selectedFromDate && moment(new Date(date).toDateString()).format("YYYY-MM-DD") !== moment(new Date(this.state.selectedFromDate).toDateString()).format("YYYY-MM-DD")) {
                MessageBox(Constants.DATE_RAGE_VALIDATION, Constants.ERROR);
            } else {
                this.setState({
                    selectedToDate: date,
                    pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 }
                }, () => {
                    this.getTMVoucherData();
                });
            }
        }
        else {
            this.setState({
                voucherList: []
            });
        }
    }

    handleFromDateChange(date) {
        if ((new Date(date) !== "Invalid Date") && !isNaN(new Date(date))) {
            if (date === null) {
                MessageBox(Constants.SELCET_FROM_DATE, Constants.ERROR);
            }
            else if (date > this.state.selectedToDate) {
                MessageBox(Constants.DATE_RAGE_VALIDATION, Constants.ERROR);
            } else {
                this.setState({
                    selectedFromDate: date,
                    pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 }
                }, () => {
                    this.getTMVoucherData();
                });
            }
        }
        else {
            this.setState({
                voucherList: []
            });
        }
    }

    onClickPrint() {
        var printTemplate = this.getAttachmentTemplate();
        var divElement = document.createElement('html');
        divElement.innerHTML = printTemplate;
        var attachmentPrint = window.open('', '', 'left=0,top=0,width=850,height=700,toolbar=0,scrollbars=2,status=0');
        attachmentPrint.document.write(divElement.innerHTML);
        attachmentPrint.document.close();
        attachmentPrint.print()
    }

    getAttachmentTemplate() {
        let { selectedTMVoucherAttachments } = this.state;
        let attachmentList = [];
        selectedTMVoucherAttachments.attachments.forEach(data => {
            attachmentList = attachmentList.concat(`
            <TR>
                <TD><img alt=${data.attachmentName} src=${Constants.DATA_BASE64 + data.attachmentContent} height="350" width="550"/></TD>
            </TR>  
            `);
        });
        let printableSheet = ` 
        <body>            
            <Table style='font-size:11px;font: 11px Trebuchet MS, Verdana, Arial, Helvetica, sans-serif;' width='650'  border='0' cellpadding='0' cellspacing='0' align='center'>
                <TBODY>              
                ${attachmentList.join(" ")}     
                </TBODY>
            </Table>
        </body>`;
        return printableSheet;
    }

    paginationChange = (e, { activePage }) => {
        let { pagination } = this.state;
        pagination.skip = ((activePage - 1) * Constants.DEFAULT_TAKE) + 1;
        pagination.take = ((activePage - 1) * Constants.DEFAULT_TAKE) + Constants.DEFAULT_TAKE;
        pagination.activePage = activePage;
        this.setState({
            pagination
        }, () => {
            this.getTMVoucherData();
        });
    }

    openAttachments = tMVoucher => {
        let { voucherList, revisionList } = this.state;
        let selectedTMvoucher;
        if (tMVoucher.tmvoucherId) {
            selectedTMvoucher = this.state.isShowRevisionModal ? (revisionList.find(b => b.id === tMVoucher.tmvoucherId)) : (voucherList.find(a => a.id === tMVoucher.tmvoucherId));
        }
        if (tMVoucher.modalOpenAttachments) {
            let url = `${ApiUrls.Routes.TMVOCHR_C}${ApiUrls.Routes.GT_ATMT_BY_TMVOCHR_M}?TMVoucherID=${tMVoucher.tmvoucherId}&&deviceId=${tMVoucher.deviceId}&&isCheckedArchive=${this.state.isCheckedArchive}`;
            Api.Get(url, this).then(response => {
                if (response.success) {
                    selectedTMvoucher.attachments = response.data;
                    this.setState({ selectedTMVoucherAttachments: selectedTMvoucher, isShowAttachments: tMVoucher.modalOpenAttachments });
                }
            });
        } else {
            this.setState({ isShowAttachments: false });
        }
    }

    buildSearchRequestArray(isFromPage) {
        let { tMVoucherEmployeeSearchText, revisionEmployeeSearchText, tMVoucherDeviceNameSearchText,
            revisionDeviceNameSeachText, tMVoucherTimecardDateSearchText, revisionTimecardDateSearchText,
            tMVoucherProjectSearchText, revisionProjectSearchText, tMVoucherTaskCodeSearchText,
            revisionTaskCodeSearchText, tMVoucherSyncedDateSearchText, revisionSyncedDateSearchText,
            tMVoucherVersionSearchText, revisionVersionSearchText, tMVoucherStatusSearchText, revisionStatusSearchText,
            tMVoucherNumberSearchText, revisionNumberSearchText, selectedSignatureTMVoucherOptions, selectedSignatureRevisionOptions } = this.state;

        let searchArray = [];
        searchArray.push({
            FieldName: Constants.USER_ID,
            Value: this.props.user.userId.toString()
        });
        if (tMVoucherEmployeeSearchText || revisionEmployeeSearchText) {
            let searchObj = {
                FieldName: Constants.TM_VOUCHER_EMPOYLEE_SEARCH,
                Value: isFromPage ? tMVoucherEmployeeSearchText : revisionEmployeeSearchText
            };
            searchArray.push(searchObj);
        };
        if (tMVoucherDeviceNameSearchText || revisionDeviceNameSeachText) {
            let searchObj = {
                FieldName: Constants.TM_VOUCHER_DEVICENAME_SEARCH,
                Value: isFromPage ? tMVoucherDeviceNameSearchText : revisionDeviceNameSeachText
            };
            searchArray.push(searchObj);
        };
        if (tMVoucherTimecardDateSearchText || revisionTimecardDateSearchText) {
            let searchObj = {
                FieldName: Constants.TM_VOUCHER_TIMECARD_DATE_SEARCH,
                Value: isFromPage ? tMVoucherTimecardDateSearchText : revisionTimecardDateSearchText
            };
            searchArray.push(searchObj);
        };
        if (tMVoucherProjectSearchText || revisionProjectSearchText) {
            let searchObj = {
                FieldName: Constants.TM_VOUCHER_PROJECT_SEARCH,
                Value: isFromPage ? tMVoucherProjectSearchText : revisionProjectSearchText
            };
            searchArray.push(searchObj);
        };
        if (tMVoucherTaskCodeSearchText || revisionTaskCodeSearchText) {
            let searchObj = {
                FieldName: Constants.TM_VOUCHER_TASKCODE_SEARCH,
                Value: isFromPage ? tMVoucherTaskCodeSearchText : revisionTaskCodeSearchText
            };
            searchArray.push(searchObj);
        };
        if (tMVoucherSyncedDateSearchText || revisionSyncedDateSearchText) {
            var syncTime = isFromPage ? new Date(tMVoucherSyncedDateSearchText.setHours(0, 0, 0)) :
                revisionSyncedDateSearchText && new Date(revisionSyncedDateSearchText.setHours(0, 0, 0));
            if (syncTime) {
                var syncDate = new Date(syncTime.setMinutes(syncTime.getTimezoneOffset()));
                var selectDate = moment(syncDate).format('DD-MM-YYYY');
                var timeZone = syncDate.toString();
                var selectTimeZone = timeZone.slice(16, 24);
                var tmvoucherSyncedDate = `${selectDate} ${selectTimeZone}`;
                let searchObj = {
                    FieldName: Constants.TM_VOUCHER_SYNCED_DATE_SEARCH,
                    Value: tmvoucherSyncedDate
                };
                searchArray.push(searchObj);
            }
        };
        if (tMVoucherVersionSearchText || revisionVersionSearchText) {
            let searchObj = {
                FieldName: Constants.TM_VOUCHER_VERSION_SEARCH,
                Value: isFromPage ? tMVoucherVersionSearchText : revisionVersionSearchText
            };
            searchArray.push(searchObj);
        };
        if (tMVoucherStatusSearchText || revisionStatusSearchText) {
            let searchObj = {
                FieldName: Constants.TM_VOUCHER_STATUS_SEARCH,
                Value: isFromPage ? tMVoucherStatusSearchText : revisionStatusSearchText
            };
            searchArray.push(searchObj);
        };
        if (tMVoucherNumberSearchText || revisionNumberSearchText) {
            let searchObj = {
                FieldName: Constants.TM_VOUCHER_NUMBER_SEARCH,
                Value: isFromPage ? tMVoucherNumberSearchText : revisionNumberSearchText
            };
            searchArray.push(searchObj);
        };

        const selectedSignatureOptions = isFromPage
            ? selectedSignatureTMVoucherOptions?.map(a => a.value).join(" ") ?? ""
            : selectedSignatureRevisionOptions?.map(a => a.value).join(" ") ?? ""

        if (selectedSignatureOptions?.length > 0) {
            const searchObj = {
                FieldName: Constants.TM_VOUCHER_SIGNATURE_SEARCH,
                Value: selectedSignatureOptions,
            };

            searchArray.push(searchObj);
        }

        return searchArray;
    }

    getRevisionList() {
        let { selectedRevisionTMVoucher } = this.state;
        let url = `${ApiUrls.Routes.TMVOCHR_C}${ApiUrls.Routes.GT_TMR_L}?isCheckedArchive=${this.state.isCheckedArchive}`;
        let searchArray = this.buildSearchRequestArray(false);;
        let searchObj = {
            FieldName: Constants.DEVICEID,
            Value: selectedRevisionTMVoucher.deviceId.toString()
        };
        searchArray.push(searchObj);
        searchObj = {
            FieldName: Constants.PROJECTID,
            Value: selectedRevisionTMVoucher.ProjectId.toString()
        };
        searchArray.push(searchObj);
        searchObj = {
            FieldName: Constants.TASKCODEID,
            Value: selectedRevisionTMVoucher.TaskCodeID.toString()
        };
        searchArray.push(searchObj);
        searchObj = {
            FieldName: "TMVoucherNumber",
            Value: selectedRevisionTMVoucher.TMVoucherNumber
        };
        searchArray.push(searchObj);
        const requestData = {
            SearchText: searchArray
        }
        Api.Post(url, requestData, this).then(responseData => {
            if (responseData.success) {
                let revisionList = responseData.data;
                this.setState({ revisionList: revisionList });
            }
        });
    }

    openTMReport(tMVoucher) {
        this.setState({ isShowTMVoucherPDF: true, selectedTMVoucher: "" }, () => {
            let url = `${ApiUrls.Routes.TMVOCHR_C}${ApiUrls.Routes.GT_PDF_ATMT_BY_TMVOCHR_M}?TMVoucherID=${tMVoucher.id}&&deviceId=${tMVoucher.deviceId}&&isCheckedArchive=${this.state.isCheckedArchive}`;
            Api.Get(url, this).then(response => {
                if (response.success) {
                    this.setState({ selectedTMVoucher: response.data });
                }
            });
        });
    }

    onClickDownload(tMVoucher) {
        let url = `${ApiUrls.Routes.TMVOCHR_C}${ApiUrls.Routes.GT_PDF_ATMT_BY_TMVOCHR_M}?TMVoucherID=${tMVoucher.id}&&deviceId=${tMVoucher.deviceId}&&isCheckedArchive=${this.state.isCheckedArchive}`;
        Api.Get(url, this).then(response => {
            if (response.success) {
                if (response.data) {
                    const downloadLink = document.createElement("a");
                    downloadLink.href = Constants.PDFDATA_BASE64 + response.data.attachmentContent;
                    downloadLink.download = tMVoucher.attachmentName ?? response.data.attachmentName;
                    downloadLink.click();
                }
            } else {
                MessageBox(response.message, Constants.ERROR);
            }
        });
    }

    closeTMReport() {
        this.setState({ isShowTMVoucherPDF: false })
    }

    openAttachmentViewer(attachment) {
        this.setState({
            isAttachmentModelVisible: true,
            selectedAttachmentContent: attachment
        });
    }

    closeAttachmentViewer() {
        this.setState({
            isAttachmentModelVisible: false,
            selectedAttachmentContent: ""
        });
    }

    openRevisionModal(selectedRevisionTMVoucher) {
        this.setState({
            isShowRevisionModal: true,
            selectedRevisionTMVoucher: selectedRevisionTMVoucher,
            selectedSignatureRevisionOptions: [],
        }, () => {
            this.getRevisionList();
        });
    }

    closeRevisionModal() {
        this.setState({
            isShowRevisionModal: false,
            selectedRevisionTMVoucher: "",
            revisionEmployeeSearchText: '',
            revisionDeviceNameSeachText: '',
            revisionTimecardDateSearchText: '',
            revisionProjectSearchText: '',
            revisionTaskCodeSearchText: '',
            revisionSyncedDateSearchText: '',
            revisionVersionSearchText: '',
            revisionStatusSearchText: '',
            revisionNumberSearchText: '',
            revisionSelectedSyncDate: null,
            revisionSelectedTimecardDate: null,
            revisionList: [],
            selectedSignatureRevisionOptions: [],
        }, () => {
            this.getTMVoucherList();
        });
    }

    closeAttachmentsModal() {
        this.setState({ isShowAttachments: false });
    }

    onChangeSignature(value) {
        if (this.state.isShowRevisionModal) {
            this.setState({ selectedSignatureRevisionOptions: value });
        } else {
            this.setState({ selectedSignatureTMVoucherOptions: value });
        }
    }

    handleArchiveCheckboxChange(isChecked) {
        let { lastArchiveDate, maximumDate, minimumDate } = this.state;
        var selectFromDate = new Date();
        var selectToDate = new Date();
        var diff = selectFromDate.getDate() - selectFromDate.getDay() + (selectFromDate.getDay() === 0 ? -6 : 1);
        selectFromDate = new Date(selectFromDate.setDate(diff));
        let result = new Date(lastArchiveDate);
        let archiveMaxDateWithMinusOneDay = new Date(result.setDate(result.getDate() - 1));
        minimumDate = lastArchiveDate;
        maximumDate = null;
        if (isChecked) {
            let tempArchiveDate = new Date(archiveMaxDateWithMinusOneDay);
            let mondayOfWeek = tempArchiveDate.getDate() - tempArchiveDate.getDay() + (tempArchiveDate.getDay() === 0 ? -6 : 1);
            selectToDate = archiveMaxDateWithMinusOneDay;
            selectFromDate = new Date(tempArchiveDate.setDate(mondayOfWeek));
            maximumDate = archiveMaxDateWithMinusOneDay;
            minimumDate = null;
        }
        this.setState({ isCheckedArchive: isChecked, selectedToDate: selectToDate, selectedFromDate: selectFromDate, minimumDate, maximumDate, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } });
        this.getTMVoucherData();
    }

    render() {
        const { voucherList, isShowRevisionModal, pagination, isShowAttachments, isShowTMVoucherPDF, selectedAttachmentContent, isAttachmentModelVisible, selectedTMVoucherAttachments, revisionList, selectedTMVoucher, selectedFromDate, selectedToDate, selectedRevisionTMVoucher, revisionEmployeeSearchText, revisionDeviceNameSeachText, revisionTimecardDateSearchText, revisionProjectSearchText, revisionTaskCodeSearchText, revisionSyncedDateSearchText, revisionVersionSearchText, revisionStatusSearchText, revisionSelectedSyncDate, tMVoucherEmployeeSearchText, tMVoucherDeviceNameSearchText, tMVoucherTimecardDateSearchText, tMVoucherProjectSearchText, tMVoucherTaskCodeSearchText, tMVoucherSyncedDateSearchText, tMVoucherVersionSearchText, tMVoucherStatusSearchText, tMVoucherSelectedSyncDate, revisionSelectedTimecardDate, tMVoucherNumberSearchText, revisionNumberSearchText, tmVoucherSelectedTimecardDate, signatureOptions, selectedSignatureTMVoucherOptions, selectedSignatureRevisionOptions, isCheckedArchive, minimumDate, maximumDate, lastArchiveDate, isDatePickerEnabled } = this.state;
        return (
            <Fragment>
                <TMVoucherComponent
                    {...{
                        tmVoucher: {
                            voucherList,
                            revisionList,
                            isShowRevisionModal,
                            isShowAttachments,
                            isShowTMVoucherPDF,
                            selectedAttachmentContent,
                            isAttachmentModelVisible,
                            selectedTMVoucherAttachments,
                            selectedTMVoucher,
                            selectedFromDate,
                            selectedToDate,
                            selectedRevisionTMVoucher,
                            revisionEmployeeSearchText,
                            revisionDeviceNameSeachText,
                            revisionTimecardDateSearchText,
                            revisionProjectSearchText,
                            revisionTaskCodeSearchText,
                            revisionSyncedDateSearchText,
                            revisionVersionSearchText,
                            revisionStatusSearchText,
                            revisionNumberSearchText,
                            revisionSelectedSyncDate,
                            tMVoucherEmployeeSearchText,
                            tMVoucherDeviceNameSearchText,
                            tMVoucherTimecardDateSearchText,
                            tMVoucherProjectSearchText,
                            tMVoucherTaskCodeSearchText,
                            tMVoucherSyncedDateSearchText,
                            tMVoucherVersionSearchText,
                            tMVoucherStatusSearchText,
                            tMVoucherNumberSearchText,
                            tMVoucherSelectedSyncDate,
                            revisionSelectedTimecardDate,
                            tmVoucherSelectedTimecardDate,
                            pagination,
                            signatureOptions,
                            selectedSignatureTMVoucherOptions,
                            selectedSignatureRevisionOptions,
                            isCheckedArchive,
                            minimumDate,
                            maximumDate,
                            lastArchiveDate,
                            isDatePickerEnabled
                        }
                    }}
                    openRevisionModal={this.openRevisionModal.bind(this)}
                    closeRevisionModal={this.closeRevisionModal.bind(this)}
                    openAttachments={this.openAttachments.bind(this)}
                    closeAttachmentsModal={this.closeAttachmentsModal.bind(this)}
                    openAttachmentViewer={this.openAttachmentViewer.bind(this)}
                    closeAttachmentViewer={this.closeAttachmentViewer.bind(this)}
                    onClickPrint={this.onClickPrint.bind(this)}
                    onSearchChange={this.onSearchChange.bind(this)}
                    handleSyncDateChange={this.handleSyncDateChange.bind(this)}
                    handleToDateChange={this.handleToDateChange.bind(this)}
                    handleFromDateChange={this.handleFromDateChange.bind(this)}
                    paginationChange={this.paginationChange.bind(this)}
                    openTMReport={this.openTMReport.bind(this)}
                    onClickDownload={this.onClickDownload.bind(this)}
                    closeTMReport={this.closeTMReport.bind(this)}
                    splitDeviceName={this.splitDeviceName.bind(this)}
                    handleTimecardDateChange={this.handleTimecardDateChange.bind(this)}
                    onChangeSignature={this.onChangeSignature.bind(this)}
                    handleArchiveCheckboxChange={this.handleArchiveCheckboxChange.bind(this)}
                    user={this.props.user}
                />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        Object.assign({},
            actions),
        dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TMVoucher));

TMVoucher.displayName = 'TMVoucher';